import { cn as cx } from "@/lib/utils";

/** Chinese line on top, English line below. Always. */
export function BilingualText({ cn, en, size = "md", className, invertColors = false }) {
  const sizes = {
    sm: { cn: "text-sm sm:text-base", en: "text-xs sm:text-sm" },
    md: { cn: "text-base sm:text-lg", en: "text-sm sm:text-base" },
    lg: { cn: "text-xl sm:text-2xl", en: "text-base sm:text-lg" },
    xl: { cn: "text-2xl sm:text-3xl", en: "text-lg sm:text-xl" },
    hero: { cn: "text-3xl sm:text-5xl", en: "text-xl sm:text-2xl" },
  }[size];

  return (
    <div className={cx("flex flex-col gap-0.5", className)}>
      <span
        className={cx(
          "cn font-bold leading-tight tracking-tight",
          sizes.cn,
          invertColors ? "text-white" : "text-slate-900",
        )}
      >
        {cn}
      </span>
      <span
        className={cx(
          "font-semibold leading-snug",
          sizes.en,
          invertColors ? "text-white/80" : "text-slate-500",
        )}
      >
        {en}
      </span>
    </div>
  );
}

export default BilingualText;
